export const CONTENT_TOGGLE_BUTTON = 'toggle-content';
